import { render } from "./pro-tip-filters.vue?vue&type=template&id=08ca2252"
import script from "./pro-tip-filters.vue?vue&type=script&lang=js"
export * from "./pro-tip-filters.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__